import initialState from '../initialState';
import * as types from './actionTypes.user';
import * as gitHubIntegrationTypes from '../gitHubIntegration/actionTypes.gitHubIntegration';

const initialStateObj = {
    ...initialState.user,
};

export default function UserReducer(state = initialStateObj, action) {
    switch (action.type) {

        case types.USER_AUTHORIZE_REQ:
            return {
                ...state,
                ...{ authorizationInProcess: true }
            };

        case types.USER_AUTHORIZE_OK:
            return {
                ...state,
                ...{
                    authorizationInProcess: false,
                    email: action.email


                }
            };

        case types.USER_AUTHORIZE_ERR:
            return {
                ...state,
                ...{ authorizationInProcess: false }
            };

        case types.SIGN_IN_USER_REQ:
            return {
                ...state,
                ...{ logInInProcess: true }
            };

        case types.SIGN_IN_USER_OK:
            return {
                ...state,
                ...{ email: action.user.email },
                ...{ logInInProcess: false }
            };

        case types.SIGN_UP_USER_REQ:
            return {
                ...state,
                ...{ logInInProcess: true }
            };

        case types.SIGN_UP_USER_OK:
            return {
                ...state,
                ...{ logInInProcess: false }
            };

        case types.SIGN_IN_USER_ERR:
        case types.SIGN_UP_USER_ERR:
            return {
                ...state,
                ...{ logInInProcess: false }
            };

        case types.VERIFY_USER_SIGN_UP_REQ:
            return {
                ...state,
                ...{ accountVerificationIsInInProcess: true }
            };

        case types.VERIFY_USER_SIGN_UP_OK:
        case types.VERIFY_USER_SIGN_UP_ERR:
            return {
                ...state,
                ...{ accountVerificationIsInInProcess: false }
            };

        case types.GET_LAST_VERIFICATION_EMAIL_INFO_OK:
            return {
                ...state,
                ...{ verificationEmailInfoData: action.verificationEmailInfoData }
            };

        case types.RESET_LAST_VERIFICATION_EMAIL_INFO_REQ:
            return {
                ...state,
                ...{
                    verificationEmailInfoData: {
                        ...state.verificationEmailInfoData,
                        ...{ showResendPopup: false }
                    }
                }
            };

        case types.GET_PROFILE_REQ:
            return {
                ...state,
                ...{ isUserLoading: true },
            };

        case types.GET_PROFILE_OK:
            return {
                ...state,
                ...action.profile,
                ...{
                    isUserLoading: false,
                    hasProfileData: true
                },
            };

        case types.GET_GITHUB_LOGIN_NAME_OK:
            return {
                ...state,
                ...action.githubLogin,
            };

        case types.GET_GITHUB_LOGIN_NAME_ERR:
            return {
                ...state,
                ...{ githubLogin: null },
            };

        case types.UPDATE_PROFILE_REQ:
            return {
                ...state,
                ...{ isUserLoading: true },
            };

        case types.UPDATE_PROFILE_OK:
            return {
                ...state,
                ...{ isUserLoading: false },
                ...action.profile
            };

        case types.CHANGE_PASSWORD_REQ:
            return {
                ...state,
                ...{ isUserLoading: true },
            };

        case types.CHANGE_PASSWORD_OK:
            return {
                ...state,
                ...{ isUserLoading: false },
            };

        case types.CHANGE_PASSWORD_ERR:
            return {
                ...state,
                ...{ isUserLoading: false },
            };


        case types.GET_USER_BALANCE_OK:
            return {
                ...state,
                ...{
                    balance: action.balance.balanceMoney / 100,
                    tier: action.balance.tier,
                    freeInteractions: action.balance.balanceFreeInteractions,
                    hasAssignedCard: action.balance.hasAssignedCard,
                    allowedToWork: action.balance.allowedToWork,
                    billingStatus: action.balance.billingStatus,
                    planId: action.balance.planId,
                    isEnterprise: action.balance.isEnterprise,
                    paidUntilTs: +action.balance.paidUntilTs,
                    cancelPlanTs: +action.balance.cancelPlanTs,
                    capabilities: action.balance.capabilities,
                    hasPaymentInfo: true
                },
            };

        case types.GET_USER_PAYMENT_METHODS_OK:
            return {
                ...state,
                ...{
                    cards: action.cards,
                },
            };

        case types.GET_PAYMENT_HISTORY_OK:
            return {
                ...state,
                ...{
                    payments: action.payments,
                },
            };

        case types.GET_GITHUB_PROMO_INFO_OK:
            return {
                ...state,
                ...{
                    interactionTotal: action.info.interactionTotal,
                    interactionBalance: action.info.interactionBalance,
                    numOfAlanProjects: action.info.numOfAlanProjects,
                    numOfStars: action.info.numOfStars,
                },
            };

        case types.GET_GITHUB_PROMO_INFO_ERR:
            return {
                ...state,
                ...{
                    interactionTotal: 0,
                    interactionBalance: 0,
                    numOfAlanProjects: 0,
                    numOfStars: 0,
                },
            };

        case types.GET_PLANS_OK:
            return {
                ...state,
                plans: action.plans,
                currentPlan: action.currentPlan,
            };

        case types.GET_INVITED_FRIENDS_INFO_OK:
            return {
                ...state,
                invitedFriends: action.invitedFriends,
                earnedFreeInteractionsPerMonth: action.earnedFreeInteractionsPerMonth,
            };

        case gitHubIntegrationTypes.REVOKE_GITHUB_ACCESS_OK:
            return {
                ...state,
                ...{ githubLogin: null },
                ...{ githubScope: null },
            };

        default:
            return state;
    }
}
